module.exports = __webpack_public_path__ + "img/person-5.df17754.webp";